import React from 'react';
import number1 from '../img/1.png';
import number2 from '../img/2.png';
import number3 from '../img/3.png';
import number4 from '../img/4.png';
import number5 from '../img/5.png';

function WhatYouWillLearn() {
  return (
    <section className="wyl-section" id="methodology">
      <h2 className="wyl-title">Чему вы научитесь</h2>
      <p class="hero-subtitle">Курс "Настройка рекламы по психотипу пользователей на основе контента соцсетей" – это инновационный инструмент, который поможет вам вывести маркетинговые кампании на принципиально новый уровень. Вы не просто получите теоретические знания – вы освоите четкий алгоритм, который уже доказал свою эффективность и используется ведущими маркетологами и брендами СНГ.</p>

      <div className="wyl-row wyl-row-top">
      <div className="wyl-card">
  <div className="wyl-flex-row">
    <div className="wyl-number">
      <img src={number1} alt="1" />
    </div>
    <h3 className="wyl-heading">
      Глубоко анализировать психологический портрет клиентов
    </h3>
  </div>

  {/* Список плюсов/под-пунктов */}
  <ul className="wyl-list">
    <li>Определять эмоциональное состояние, мотивацию и ключевые триггеры пользователей</li>
    <li>Анализировать их поведение в соцсетях: посты, лайки, комментарии, подписки</li>
    <li>Применять модели Big Five (OCEAN), MBTI, Customer Personas для сегментации аудитории</li>
  </ul>
</div>


<div className="wyl-card">
  {/* Верхняя часть (цифра + заголовок в одну строку) */}
  <div className="wyl-flex-row">
    <div className="wyl-number">
      <img src={number2} alt="1" />
    </div>
    <h3 className="wyl-heading">
    Настраивать рекламу с максимальной точностью
    </h3>
  </div>

  {/* Список плюсов/под-пунктов */}
  <ul className="wyl-list">
    <li>Создавать персонализированные рекламные кампании на основе психотипов клиентов</li>
    <li>Определять лучшие рекламные платформы для каждого сегмента аудитории (Instagram, TikTok, Facebook, YouTube)</li>
    <li>Разрабатывать динамический контент, который адаптируется под каждого пользователя</li>
  </ul>
</div>
      </div>

      <div className="wyl-row wyl-row-top">
      <div className="wyl-card">

  <div className="wyl-flex-row">
    <div className="wyl-number">
      <img src={number3} alt="3" />
    </div>
    <h3 className="wyl-heading">
    Оптимизировать рекламный бюджет и снижать стоимость привлечения клиентов (CAC)
    </h3>
  </div>

  <ul className="wyl-list">
    <li>Использовать AI-алгоритмы и Big Data для автоматической корректировки таргетинга</li>
    <li>Снижать рекламные расходы за счет точечного попадания в целевую аудиторию</li>
    <li>Повышать конверсию без увеличения бюджета благодаря нейросетевому анализу поведения пользователей</li>
  </ul>
</div>

<div className="wyl-card">

<div className="wyl-flex-row">
  <div className="wyl-number">
    <img src={number4} alt="4" />
  </div>
  <h3 className="wyl-heading">
  Развивать стратегический подход в digital-маркетинге
  </h3>
</div>

<ul className="wyl-list">
  <li>Выстраивать долгосрочные стратегии клиентской лояльности</li>
  <li>Интегрировать NLP, AI и предиктивную аналитику в работу маркетинговых команд</li>
  <li>Разрабатывать персонализированный контент для разных сегментов пользователей</li>
</ul>
</div>


      </div>
      <div className="wyl-row wyl-row-top">

      <div className="wyl-card">

<div className="wyl-flex-row">
  <div className="wyl-number">
    <img src={number5} alt="5" />
  </div>
  <h3 className="wyl-heading">
  Повышать эффективность рекламных кампаний в 2–3 раза
  </h3>
</div>

<ul className="wyl-list">
  <li>Улучшать CTR (кликабельность объявлений) на 30-50%</li>
  <li>Повышать ROI (возврат инвестиций в рекламу) в 1,5–2 раза</li>
  <li>Создавать по-настоящему вовлекающую и нативную рекламу, на которую пользователи будут реагировать</li>
</ul>
</div>

      </div>
    </section>
  );
}

export default WhatYouWillLearn;
